var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hide)?_c('div',{class:_vm.cssClass},[_c('Header'),_c('div',{class:_vm.$style.content},[_c('aside',{class:_vm.$style.sidebar},[(_vm.menu.length > 0 && _vm.render)?_c('Sidebar'):_vm._e()],1),_c('main',{class:_vm.$style.main},[_vm._t("default")],2)]),_c('Footer',{attrs:{"auth":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }